import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from 'src/app/commons/generic.service';
import { FormaSolicitacao } from 'src/app/model/formaSolicitacao';

@Injectable({
  providedIn: 'root'
})
export class FormaSolicitacaoService extends GenericService {

  private relativePath = 'api/formaSolicitacao';
  resultadoChamado: Observable<string>;

  constructor(http: HttpClient) {
      super(http);
  }

  obterListaFormaSolicitacao(): Observable<Array<FormaSolicitacao>> {
    return this.http.get<Array<FormaSolicitacao>>(this.url + this.relativePath + '/find-All');
}
}
